import { createApi } from '@reduxjs/toolkit/query/react';
import { isomorphicWebApiBaseQuery } from 'tradera/state/services/utils/webapi-base-query';

export const webApiTags = {
    Item: 'Item',
    Offer: 'Offer',
    KycPendingActions: 'KycPendingActions',
    KycQuestionnaire: 'KycQuestionnaire',
    MemberVerificationStatus: 'MemberVerificationStatus',
};

export const webApi = createApi({
    reducerPath: 'webApi',
    tagTypes: [
        webApiTags.Item,
        webApiTags.Offer,
        webApiTags.KycPendingActions,
        webApiTags.KycQuestionnaire,
        webApiTags.MemberVerificationStatus,
    ],
    baseQuery: isomorphicWebApiBaseQuery,
    // endpoints are added through injectEndpoints
    endpoints: () => ({}),
});
